<template>
  <div class="start-page">
    <div id="tipping" class="loading-parent">
      <div class="userinfo">
        <div class="hi">Hi, {{ displayName }}</div>
        <div class="row row-sb">
          <div class="commission-item">
            <div class="com-title">{{ $t('抢单.今日收益') }}</div>
            <div class="money">$ {{ todayIncome }}</div>
          </div>
          <div class="commission-item">
            <div class="com-title">{{ $t('抢单.余额') }}</div>
            <div class="money">$ {{ balance }}</div>
          </div>
        </div>
        <div class="row row-sb">
          <div class="menu-order" @click="goFundRecord">
            <img src="/img/start/order-list.png" alt="" class="menu-order_img" />
            <div class="info">{{ $t('抢单.订单') }}</div>
          </div>
          <div
            class="menu-order"
            :class="{ disabled: grabBusy || isDailyLimitReached }"
            @click="startGrab"
          >
            <img src="/img/start/order.png" alt="" class="menu-order_img" />
            <div class="info" style="align-items: center;">
              <span style="text-align: center;">{{ $t('抢单.开始抢单') }}</span>
              <span class="order-limit-text">
                ({{ todayCompleted }}/{{ dailyLimit }})
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="main-body">
        <div class="vip-info" @click="goMembership">
          <span>VIP</span>
          <div class="row column-c vip-right">
            <span>{{ $t('抢单.当前等级') }}</span>
            <span>{{ vipLabel }}</span>
            <img src="/img/start/vip.png" alt="" />
            <van-icon name="arrow" />
          </div>
        </div>

        <div class="menu-list">
          <div class="menu-item" @click="goWithdraw">
            <div class="row column-c">
              <img src="/img/start/withdraw.png" alt="" />
              <span>{{ $t('抢单.提现') }}</span>
            </div>
            <van-icon name="arrow" />
          </div>
          <div class="menu-item" @click="goService">
            <div class="row column-c">
              <img src="/img/start/contact.png" alt="" />
              <span>{{ $t('抢单.在线客服') }}</span>
            </div>
            <van-icon name="arrow" />
          </div>
          <div class="menu-item" @click="goRecharge">
            <div class="row column-c">
              <img src="/img/start/recharge.png" alt="" />
              <span>{{ $t('抢单.充值') }}</span>
            </div>
            <van-icon name="arrow" />
          </div>
          <div class="menu-item" @click="goFundRecord">
            <div class="row column-c">
              <img src="/img/start/lucky-task.png" alt="" />
              <span>{{ $t('抢单.幸运任务') }}</span>
            </div>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </div>

    <LuckyOrderIntro
      :visible="showLuckyIntro"
      :commission="luckyCommission"
      @done="onLuckyIntroDone"
    />

    <div v-if="showOrderModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ $t('抢单.提交订单') }}</h3>
          <button class="close-btn" @click="closeModal" :disabled="orderLoading">&times;</button>
        </div>

        <div class="modal-body">
          <div v-if="loading" class="loading-order">
            <van-loading type="spinner" color="#e6b98a" size="24px" />
            <span>{{ $t('抢单.正在获取订单') }}</span>
          </div>

          <div v-else-if="currentOrder" class="order-info">
            <div class="order-time">
              <span class="time-label">{{ $t('抢单.抢单时间') }}</span>
              <span class="time-value">{{ grabTime }}</span>
            </div>
            <div class="order-number">
              <span class="number-label">{{ $t('抢单.订单号') }}</span>
              <span class="number-value">{{ orderId }}</span>
            </div>
            <div class="goods-card">
              <div v-if="currentOrder.goods_pic" class="goods-image-section">
                <img
                  :src="currentOrder.goods_pic"
                  :alt="currentOrder.goods_name"
                  class="goods-image"
                  @error="handleImageError"
                />
              </div>
              <div class="goods-info-section">
                <div class="goods-name">{{ currentOrder.goods_info || currentOrder.goods_name }}</div>
                <div class="goods-brand">Kanta Lekap</div>
              </div>
            </div>
            <div class="amount-summary">
              <div class="amount-row">
                <div class="amount-item">
                  <span class="amount-label">{{ $t('抢单.订单总额') }}</span>
                  <span class="amount-value">{{ currentOrder.goods_price }}</span>
                </div>
                <div class="amount-item">
                  <span class="amount-label">{{ $t('抢单.佣金') }}</span>
                  <span class="commission-value">
                    {{ currentOrder.commission }}
                  </span>
                </div>
              </div>
            </div>
            <div class="pay-password-wrap" v-if="needPayPasswordInput">
              <input
                v-model="paypassword"
                type="password"
                class="pay-password-input"
                :placeholder="$t('订单历史.请输入支付密码')"
                autocomplete="off"
                :disabled="orderLoading"
              />
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="cancel-btn" @click="closeModal" :disabled="orderLoading">
            {{ $t('抢单.取消') }}
          </button>
          <button
            class="place-order-btn"
            @click="placeOrder"
            :disabled="!currentOrder || orderLoading || loading"
          >
            <span v-if="orderLoading">{{ $t('抢单.支付处理中') }}</span>
            <span v-else>{{ $t('抢单.确认付款') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http/index'
import { Dialog } from 'vant'
import LuckyOrderIntro from '@/common/LuckyOrderIntro.vue'

export default {
  name: 'StartPage',
  components: { LuckyOrderIntro },

  data() {
    return {
      showOrderModal: false,
      showLuckyIntro: false,
      currentOrder: null,
      grabTime: '',
      loading: false,
      orderLoading: false,
      grabbing: false,
      userInfo: null,
      userLoading: false,
      paypassword: '',
    }
  },

  created() {
    const autoGrab = this.$route.query.autoGrab
    if (autoGrab) {
      this.$router.replace({ path: '/Start' })
    }
    this.getUserInfo().then(() => {
      if (autoGrab) this.startGrab()
    })
  },

  computed: {
    grabBusy() {
      return this.userLoading || this.grabbing || this.orderLoading
    },
    displayName() {
      if (!this.userInfo) return ''
      return this.userInfo.username || this.userInfo.name || ''
    },
    todayIncome() {
      return this.userInfo ? this.userInfo.today_total_commission : ''
    },
    balance() {
      return this.userInfo ? this.userInfo.balance : ''
    },
    vipLabel() {
      if (!this.userInfo || this.userInfo.vip === undefined || this.userInfo.vip === null || this.userInfo.vip === '') {
        return ''
      }
      const text = String(this.userInfo.vip)
      return text.toUpperCase().indexOf('VIP') === 0 ? text : 'VIP ' + text
    },
    todayCompleted() {
      if (!this.userInfo || !this.userInfo.daily_order_limit) return ''
      return this.userInfo.daily_order_limit.today_completed
    },
    dailyLimit() {
      if (!this.userInfo || !this.userInfo.daily_order_limit) return ''
      return this.userInfo.daily_order_limit.daily_limit
    },
    isDailyLimitReached() {
      if (this.todayCompleted === '' || this.dailyLimit === '') return false
      return Number(this.todayCompleted) >= Number(this.dailyLimit)
    },
    orderId() {
      if (!this.currentOrder) return ''
      return this.currentOrder.order_id || this.currentOrder.id
    },
    isLuckyOrder() {
      return !!(this.currentOrder && this.currentOrder.order_type === 'card_order')
    },
    luckyCommission() {
      return this.isLuckyOrder && this.currentOrder ? this.currentOrder.commission : ''
    },
    hasPayPassword() {
      return !!(this.userInfo && this.userInfo.paypassword)
    },
    needPayPasswordInput() {
      if (!this.hasPayPassword) return false
      const raw = this.userInfo && this.userInfo.daily_order_limit
        ? Number(this.userInfo.daily_order_limit.today_raw || 0)
        : 0
      return raw === 0
    },
  },

  methods: {
    async getUserInfo() {
      this.userLoading = true
      try {
        const result = await http({ method: 'get', url: 'user_info' })
        if (result && result.code === 200) {
          this.userInfo = result.data
        }
      } catch (e) {
        // ignore
      } finally {
        this.userLoading = false
      }
    },

    formatNow() {
      const now = new Date()
      const p = (v) => String(v).padStart(2, '0')
      return `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())} ${p(now.getHours())}:${p(now.getMinutes())}:${p(now.getSeconds())}`
    },

    /** 开始抢单：先拉单，有单再弹窗 */
    async startGrab() {
      if (this.grabBusy) return
      await this.getUserInfo()
      if (!this.hasPayPassword) {
        this.$toast(this.$t('订单历史.请先设置支付密码'))
        this.$router.push({ path: '/SetPayPassword', query: { from: 'start' } })
        return
      }
      if (this.isDailyLimitReached) {
        this.$toast(this.$t('抢单.今日抢单已达上限'))
        return
      }

      this.grabbing = true
      this.$toast.loading({
        message: this.$t('抢单.正在获取订单'),
        forbidClick: true,
        duration: 0,
      })

      const ok = await this.fetchOrder()
      this.$toast.clear()
      this.grabbing = false

      if (ok) {
        this.paypassword = ''
        if (this.isLuckyOrder) {
          this.showLuckyIntro = true
        } else {
          this.showOrderModal = true
        }
      }
    },

    onLuckyIntroDone() {
      this.showLuckyIntro = false
      this.showOrderModal = true
    },

    /**
     * 拉取一单
     * @returns {Promise<boolean>} 是否拿到可展示订单
     */
    async fetchOrder() {
      this.loading = true
      this.currentOrder = null
      try {
        const result = await http({ method: 'get', url: 'getUserOrders' })
        if (result && result.code === 200 && result.data && result.data.orders && result.data.orders.length) {
          this.currentOrder = result.data.orders[0]
          this.grabTime = this.formatNow()
          return true
        }

        if (result && result.code === 402) {
          this.showOrderModal = false
          Dialog.confirm({
            title: this.$t('抢单.提交订单'),
            message: result.msg || this.$t('抢单.未完成订单提示'),
            confirmButtonText: this.$t('抢单.去查看'),
            cancelButtonText: this.$t('抢单.取消'),
          })
            .then(() => this.$router.push('/GameRecord'))
            .catch(() => {})
          return false
        }

        this.$toast(result && result.msg ? result.msg : this.$t('抢单.暂无可用订单'))
        return false
      } catch (e) {
        this.$toast(this.$t('抢单.获取订单失败'))
        return false
      } finally {
        this.loading = false
      }
    },

    closeModal() {
      if (this.orderLoading) return
      this.showOrderModal = false
      this.showLuckyIntro = false
      this.currentOrder = null
      this.grabTime = ''
      this.paypassword = ''
      this.getUserInfo()
    },

    async placeOrder() {
      if (!this.currentOrder || this.orderLoading) return

      if (!this.hasPayPassword) {
        this.$toast(this.$t('订单历史.请先设置支付密码'))
        this.$router.push('/SetPayPassword')
        return
      }
      if (this.needPayPasswordInput && !this.paypassword) {
        this.$toast(this.$t('订单历史.请输入支付密码'))
        return
      }

      this.orderLoading = true
      try {
        const data = {
          order_id: this.orderId,
          quantity: 1,
        }
        if (this.needPayPasswordInput) {
          data.paypassword = this.paypassword
        }
        const result = await http({
          method: 'post',
          url: 'placeOrder',
          data,
        })

        if (!(result && result.code === 200)) {
          this.$toast(result && result.msg ? result.msg : this.$t('抢单.支付失败'))
          return
        }

        this.$toast.success(this.$t('抢单.支付成功'))
        this.showOrderModal = false
        this.showLuckyIntro = false
        this.currentOrder = null
        this.grabTime = ''
        this.paypassword = ''
        await this.getUserInfo()
      } catch (e) {
        this.$toast(this.$t('抢单.支付失败请重试'))
      } finally {
        this.orderLoading = false
      }
    },

    handleImageError(event) {
      event.target.style.display = 'none'
    },

    goWithdraw() {
      if (this.userInfo && !this.userInfo.paypassword) {
        this.$toast(this.$t('提现.请先设置提现密码'))
        this.$router.push('/SetPayPassword')
        return
      }
      this.$router.push('/Withdraw')
    },
    goService() {
      this.$router.push('/ServiceOnline')
    },
    goRecharge() {
      this.$router.push('/recharge')
    },
    goFundRecord() {
      this.$router.push('/GameRecord')
    },
    goMembership() {
      this.$router.push('/membership')
    },
  },
}
</script>

<style scoped>
.start-page {
  position: relative;
  background-color: rgb(31, 28, 31);
  min-height: 100vh;
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  touch-action: none;
}

#tipping {
  background: url("/img/login/page-bg.png") center top / 100% no-repeat;
  padding: 36.4vw 0 16vw;
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
}

.userinfo {
  padding: 0 7.28vw;
}

.hi {
  color: rgb(255, 255, 255);
  font-size: 8.32vw;
  font-weight: 700;
}

.row {
  display: flex;
}

.row-sb {
  justify-content: space-between;
}

.column-c {
  align-items: center;
}

.commission-item {
  width: 48%;
  margin-top: 3.12vw;
}

.com-title {
  font-size: 3.52vw;
  font-weight: 700;
  color: rgb(255, 205, 156);
}

.money {
  margin-top: 1.04vw;
  color: rgb(255, 255, 255);
  font-weight: 700;
  font-size: 5.2vw;
}

.menu-order {
  width: 48%;
  margin-top: 4.16vw;
  position: relative;
  cursor: pointer;
  transition: transform 0.2s;
}

.menu-order.disabled {
  opacity: 0.55;
  pointer-events: none;
}

.menu-order:active {
  transform: scale(0.98);
}

.menu-order_img {
  display: block;
  width: 100%;
  border-radius: 2.133vw;
}

.info {
  position: absolute;
  inset: 0 0 0 14.56vw;
  display: flex;
  font-size: 3.44vw;
  flex-direction: column;
  justify-content: center;
  font-weight: 700;
  color: rgb(0, 0, 0);
}

.order-limit-text {
  font-weight: 400;
  font-size: 3.12vw;
}

.main-body {
  padding: 0 3.52vw;
}

.vip-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: rgb(255, 255, 255);
  padding: 0 4.16vw 0 16.64vw;
  margin-top: 4.16vw;
  height: 14.32vw;
  background: url("/img/vip/bg.png") 50% center / 100% 100% no-repeat;
  border: none;
  border-radius: 2.133vw;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
}

.vip-right span {
  color: rgb(243, 199, 162);
  margin-right: 1.333vw;
  font-size: 3.733vw;
}

.vip-right img {
  width: 10.4vw;
  margin-left: 1.333vw;
}

.menu-list {
  background: rgb(255, 255, 255);
  margin-top: 4.16vw;
  padding: 0 3.12vw;
  border-radius: 3.12vw;
}

.menu-item {
  height: 14.56vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.267vw solid rgb(224, 224, 224);
  cursor: pointer;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item img {
  width: 10.4vw;
  margin-right: 4.16vw;
}

.menu-item span {
  color: rgb(0, 0, 0);
  font-size: 3.733vw;
  font-weight: 500;
}

.menu-item >>> .van-icon-arrow {
  color: rgb(101, 81, 66);
}

.vip-info >>> .van-icon-arrow {
  color: rgb(243, 199, 162);
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 2.667vw;
}

.modal-content {
  background: #212121;
  border-radius: 2.667vw;
  width: 100%;
  max-width: 80vw;
  border: 1px solid #766350;
  box-shadow: 0 1.333vw 5.333vw rgba(0, 0, 0, 0.5);
  position: relative;
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4vw 4.8vw;
  border-bottom: 1px solid #333;
}

.modal-header h3 {
  margin: 0;
  font-size: 4.267vw;
  font-weight: 600;
  color: #e6b98a;
}

.close-btn {
  background: #333;
  border: 1px solid #555;
  font-size: 3.733vw;
  cursor: pointer;
  color: #999;
  width: 7.467vw;
  height: 7.467vw;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.close-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.modal-body {
  padding: 3.2vw 4.8vw;
}

.modal-footer {
  padding: 3.2vw 4.8vw;
  border-top: 1px solid #333;
  display: flex;
  gap: 2.133vw;
  justify-content: space-between;
}

.order-info {
  display: flex;
  flex-direction: column;
  gap: 2.667vw;
}

.order-time,
.order-number {
  display: flex;
  align-items: center;
  gap: 1.6vw;
}

.time-label,
.number-label {
  font-size: 3.2vw;
  color: #999;
  font-weight: 500;
  white-space: nowrap;
}

.time-value,
.number-value {
  font-size: 3.467vw;
  color: #e6b98a;
  font-weight: 600;
}

.goods-card {
  display: flex;
  gap: 2.667vw;
  padding: 2.667vw;
  background: #2a2a2a;
  border-radius: 1.6vw;
  border: 1px solid #444;
}

.goods-image-section {
  flex: 0 0 13.333vw;
}

.goods-image {
  width: 13.333vw;
  height: 13.333vw;
  object-fit: cover;
  border-radius: 1.067vw;
  border: 1px solid #555;
}

.goods-info-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.333vw;
}

.goods-name {
  font-size: 3.467vw;
  color: #fff;
  font-weight: 600;
  line-height: 1.4;
}

.goods-brand {
  font-size: 2.933vw;
  color: #999;
}

.amount-summary {
  padding: 2.667vw;
  background: #2a2a2a;
  border-radius: 1.6vw;
  border: 1px solid #444;
}

.amount-row {
  display: flex;
  flex-direction: column;
  gap: 1.867vw;
}

.amount-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.amount-label {
  font-size: 3.2vw;
  color: #999;
  font-weight: 500;
}

.amount-value {
  font-size: 3.733vw;
  color: #fff;
  font-weight: 700;
}

.commission-value {
  font-size: 3.733vw;
  color: #f97316;
  font-weight: 700;
}

.pay-password-wrap {
  margin-top: 1.067vw;
}

.pay-password-input {
  width: 100%;
  box-sizing: border-box;
  padding: 2.667vw 3.2vw;
  font-size: 3.467vw;
  color: #f3c7a2;
  background: #2a2a2a;
  border: 1px solid #444;
  border-radius: 1.6vw;
  outline: none;
}

.pay-password-input::placeholder {
  color: #766350;
}

.pay-password-input:focus {
  border-color: #766350;
}

.pay-password-input:disabled {
  opacity: 0.6;
}

.place-order-btn {
  flex: 1;
  background: linear-gradient(to right, #efcba7, #dcab76);
  color: #68302c;
  border: none;
  border-radius: 1.6vw;
  padding: 2.667vw 4.8vw;
  font-size: 3.733vw;
  font-weight: 700;
  cursor: pointer;
}

.place-order-btn:disabled {
  background: #444;
  color: #666;
  cursor: not-allowed;
}

.cancel-btn {
  background: #2a2a2a;
  color: #999;
  border: 1px solid #444;
  border-radius: 1.6vw;
  padding: 2.667vw 4.8vw;
  font-size: 3.733vw;
  font-weight: 600;
  cursor: pointer;
}

.cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.loading-order {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.133vw;
  padding: 8vw 2.667vw;
  border-radius: 2.133vw;
  margin: 2.667vw 0;
  font-size: 3.733vw;
  color: #e6b98a;
  background: rgba(230, 185, 138, 0.08);
  border: 1px solid #766350;
}
</style>